import {
  topLeaderBoardBanner,
  linkModule,
  menu,
  featuredProducts,
  titleTextColor,
  buttonThemeUuid,
  displayProductPromotionTag,
  displayProductReview,
  display2ndCurrencyPrice,
  gridSetting,
  displayRRP,
  displayProductDescription,
} from './constant';

const topLeaderBoardBannerFields = [[topLeaderBoardBanner, linkModule]];

const menuFields = [[menu]];

const gridSettingFields = [
  [gridSetting, buttonThemeUuid],
  [gridSetting, displayProductDescription],
  [gridSetting, displayRRP],
  [gridSetting, display2ndCurrencyPrice],
  [gridSetting, displayProductReview],
  [gridSetting, displayProductPromotionTag],
];

const featureProductsFields = [[featuredProducts, titleTextColor]];

export {
  topLeaderBoardBannerFields,
  menuFields,
  featureProductsFields,
  gridSettingFields,
};
